var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "current",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74219 7.1875H7.49219V8.4375H8.74219V7.1875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 1.25H13.4922V0H12.2422V1.25H3.99219V0H2.74219V1.25H1.99219C0.958313 1.25 0.117188 2.09113 0.117188 3.125V14.125C0.117188 15.1589 0.958313 16 1.99219 16H6.14844H6.24219H8.42225C7.99012 15.6433 7.61375 15.2215 7.30778 14.75H6.24219H6.14844H1.99219C1.64756 14.75 1.36719 14.4696 1.36719 14.125V5.875H14.8672V7.125V7.1875V7.19059C15.3387 7.49656 15.7605 7.87297 16.1172 8.30506V7.1875V7.125V3.125C16.1172 2.09113 15.2761 1.25 14.2422 1.25ZM14.8672 4.625H1.36719V3.125C1.36719 2.78038 1.64756 2.5 1.99219 2.5H2.74219V3.75H3.99219V2.5H12.2422V3.75H13.4922V2.5H14.2422C14.5868 2.5 14.8672 2.78038 14.8672 3.125V4.625Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8984 7.5625C9.57222 7.5625 7.67969 9.45503 7.67969 11.7812C7.67969 14.1075 9.57222 16 11.8984 16C14.2247 16 16.1172 14.1075 16.1172 11.7812C16.1172 9.45503 14.2247 7.5625 11.8984 7.5625ZM11.8984 14.75C10.2615 14.75 8.92969 13.4182 8.92969 11.7812C8.92969 10.1443 10.2615 8.8125 11.8984 8.8125C13.5354 8.8125 14.8672 10.1443 14.8672 11.7812C14.8672 13.4182 13.5354 14.75 11.8984 14.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 9.6875H11.2422V12.4062H13.5547V11.1562H12.4922V9.6875Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24219 9.6875H4.99219V10.9375H6.24219V9.6875Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74219 9.6875H2.49219V10.9375H3.74219V9.6875Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74219 7.1875H2.49219V8.4375H3.74219V7.1875Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74219 12.1875H2.49219V13.4375H3.74219V12.1875Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24219 7.1875H4.99219V8.4375H6.24219V7.1875Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24219 12.1875H4.99219V13.4375H6.24219V12.1875Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.b07d92b5.svg";
export { ForwardRef as ReactComponent };